import { Outlet } from 'react-router-dom';
import IntakeHeader from '../components/IntakeHeader';
import { useIsEmbeddedMode } from '../context/EmbeddedModeContext';
import { useConfig } from '../hooks';

const IntakeToolLayout = () => {
  const { data: chatbotConfig, isLoading: isConfigLoading } = useConfig();
  const isEmbeddedMode = useIsEmbeddedMode();

  if (isConfigLoading || !chatbotConfig) {
    return <div>Loading...</div>;
  }

  if (isEmbeddedMode) {
    return (
      <>
        <title>{`Intake Tool | ${chatbotConfig.title}`}</title>
        <Outlet />
      </>
    );
  }

  return (
    <div className="flex flex-col h-screen">
      <title>{`Intake Tool | ${chatbotConfig.title}`}</title>
      <IntakeHeader />
      <div className="flex-1 overflow-auto min-h-0">
        <Outlet />
      </div>
    </div>
  );
};

export default IntakeToolLayout;
